import ContactUs from 'modules/website/components/ContactUs/ContactUs'
import React from 'react'

export default function ContactUsView() {
  return (
    <ContactUs/>
  )
}
